import { render } from "./CreditosComponent.vue?vue&type=template&id=66118960"
import script from "./CreditosComponent.vue?vue&type=script&lang=js"
export * from "./CreditosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__